import ReactModal from 'react-modal';
import classNames from 'classnames';
import Modal from '../../containers/modal.jsx';
import styles from './login-modal.css';
import React from 'react';
import PropTypes from 'prop-types';
import Box from '../box/box.jsx';
import {closeLoginModal} from '../../reducers/modals';
import {userLogined} from '../../reducers/user-state';
import {connect} from 'react-redux';
import {defineMessages, intlShape, injectIntl} from 'react-intl';
const LoginModal = ({
    password,
    username,
    title,
    onCanel,
    onLogin,
    onUserChange,
    onPasswordChange
}) => (
   <ReactModal
        isOpen
        className={classNames(styles.modalContent)}
        contentLabel={title}
        overlayClassName={styles.modalOverlay}
    >
             <div className={styles.released_illustration}><span>登陆</span></div>
             <div className={styles.released_body}>
                <div className={styles.released_relbox}>
                    <p>用户名</p>
                    <input type="text"  onChange={onUserChange}/>
                </div>
               <div className={styles.released_relbox}>
                    <p>密码</p>
                    <input type="text"  onChange={onPasswordChange} />
                </div>
                <div className={styles.releasedButtonRow}>
                    <button type="button" className={styles.releasedOkButton} onClick={onLogin}>
                        <span className={styles.buttonOutlinedButton} role="button">
                            <div className={styles.buttonContent}>
                                <span>确认</span>
                            </div>
                        </span>
                    </button>
                    <button className={styles.releasedNoButton} id="closeLoginModal" onClick={onCanel}>
                        <span>取消</span>
                    </button>
                </div>
            </div>
    </ReactModal>
);
LoginModal.propTypes = {
    title: PropTypes.string.isRequired,
    username: PropTypes.string,
    password: PropTypes.string,
    onCanel: PropTypes.func,
    onLogin: PropTypes.func,
    onUserChange: PropTypes.func,
    onPasswordChange: PropTypes.func,
    userLogin: PropTypes.func
}

LoginModal.defaultProps = {

    password: null,
    username: null,
    title:null,
    onUserChange:(e)=>{

        let val=e.target.value;
        userdata.username = val;
    },

     onPasswordChange:(e)=>{

        let val=e.target.value;
        userdata.password = val;
    },
    onLogin:()=>{

        const rootEle = document.getElementById("closeLoginModal");
        let url = window.scratchConfig.localhost+"/signin";

        var opts = {
            method:"POST",   //请求方法
            body:"username="+userdata.username+"&userpwd="+ userdata.password,   //请求体
    　　　　　headers: {
       　　　　 'Accept': 'application/json',
       　　　　 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
     　　　　 },


        }

        fetch(url,opts)
            .then((response) => {
                return response.json()
            })
            .then((res) => {
                if(res.status == 'success'){
                    window.scratchConfig.userdata = res.data;
                    window.scratchConfig.userID=res.data._id;
                    window.scratchConfig.username=res.data.username;
                    userLogined();
                    rootEle.click();
                }
            })
            .catch((error) => {
                alert(error)
            })
        }



};

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
    //userLogin: () => dispatch(userLogined()),
    onCanel: () => dispatch(closeLoginModal()),
});


export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(LoginModal));


const userdata={
    
    username:"",
    password:""
}